module.exports = __webpack_public_path__ + "media/images/email_templates/member_announcement_thumbnail-07c279b6807f7c87d2b97ad58aabacf6.png";